import { Link } from "react-router-dom";

interface TextLinkProps {
  text?: string;
  linkText?: string;
  to: string;
  onClick?: (e: React.MouseEvent) => void;
}

const TextLink: React.FC<TextLinkProps> = ({ text, linkText, to, onClick }) => {
  return (
    <div className="flex items-center space-x-2">
      <span>{text}</span>
      <Link
        to={to}
        className="text-custom-dark-purple text-sm hover:underline font-bold"
        onClick={onClick}
      >
        {linkText}
      </Link>
    </div>
  );
};

export default TextLink;
